import { createFileRoute, Outlet, useChildMatches, useRouter } from '@tanstack/react-router';
import { InvoiceDetailPanel } from '@/components/organisms/invoices/InvoiceDetailPanel';

const INVOICE_TABS = ['overview', 'payments', 'notes', 'internal'] as const;
type InvoiceTab = (typeof INVOICE_TABS)[number];

export const Route = createFileRoute('/_dashboard/dashboard/invoices/$id')({
  validateSearch: (search): { tab: InvoiceTab } => ({
    tab: INVOICE_TABS.includes(search.tab as InvoiceTab) ? (search.tab as InvoiceTab) : 'overview',
  }),
  component: InvoiceDetailPage,
});

function InvoiceDetailPage() {
  const { id } = Route.useParams();
  const { tab } = Route.useSearch();
  const router = useRouter();
  const childMatches = useChildMatches();

  if (childMatches.length > 0) {
    return <Outlet />;
  }

  return (
    <InvoiceDetailPanel
      id={id}
      tab={tab}
      onDiscarded={() =>
        void router.navigate({
          to: '/dashboard/invoices',
          search: { status: 'all', q: '', page: 1 } as never,
        })
      }
      onTabChange={(newTab) =>
        void router.navigate({
          search: (prev) => ({ ...prev, tab: newTab }) as never,
          replace: true,
        })
      }
    />
  );
}
